import React from 'react';
import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-react';
import { Link } from 'react-router-dom';
import { SiteList } from '@/components/sites/SiteList';
import { useAppCache } from '@/contexts/AppCacheContext';

/**
 * Sites Page
 *
 * Provides a comprehensive view of all user sites/deployments with
 * management capabilities and quick access to create new sites.
 *
 * Following Dieter Rams principles:
 * - Useful: Clear site management with actionable controls
 * - Understandable: Intuitive layout with familiar patterns
 * - Aesthetic: Clean, minimal design focused on content
 */

const Sites: React.FC = () => {
  const { hasPermission } = useAppCache();
  const canCreate = hasPermission('create:sites');

  return (
    <div className="min-h-screen">
      <div className="max-w-7xl mx-auto pt-5 pb-6">
        <div className="mb-8 flex items-center justify-between">
          <div>
            <h1 className="text-3xl sm:text-4xl font-bold text-foreground">Sites</h1>
            <p className="text-sm text-muted-foreground mt-2">
              Manage and edit your landing sites.
            </p>
          </div>
          {canCreate && (
            <Button variant="primary" size="default" asChild>
              <Link to="/templates">
                <Plus className="h-4 w-4 stroke-[1.5]" />
                Create new site
              </Link>
            </Button>
          )}
        </div>

        {/* SiteList Component */}
        <SiteList />
      </div>
    </div>
  );
};

export default Sites;